export default "__VITE_ASSET__x6M1Adng__"